// Cor da marca usada quando o host não tem layout cadastrado (a API de layout
// responde 200 com corpo vazio) ou quando a chamada falha. Mantida em um único
// lugar para que styles/global.js e contexts/layout.js não divirjam.
export const DEFAULT_PRIMARY_COLOR = '#604A99';
